<div *ngIf="type==='simple'">
  {{percentage}}%
</div>